'use strict';

import * as dom from '../lib/dom.js';
import simpleParallax from 'simple-parallax-js';
let instancesParalaxUp = [];
let instancesParalaxDown = [];
import AOS from 'aos';

const navPodcast = ()=>{
    //console.log('nav content loaded s');
    const NavPodcastItems = document.querySelectorAll('.js-control-podcast-nav li:not(.nav-apoie) a' );

    NavPodcastItems.forEach((el)=>{
        el.addEventListener ('click', function(e) {
            e.preventDefault();
            //console.log('eliIndex');
            const oldElActice = document.querySelector('.js-control-podcast-nav li a.active' );
            if (oldElActice) {
                dom.removeClass(oldElActice, 'active');
            }

            dom.addClass(el, 'active');


            const tabActive = this.getAttribute('data-tab');
            if(tabActive){
                //console.log(tabActive);
                const oldEventsActive = document.querySelectorAll('.c-tab-podcast' );
                const event = document.querySelector('[data-tab-content="'+tabActive+'"]');
                console.log(oldEventsActive);

                oldEventsActive.forEach((el) => {
                    dom.removeClass(el, 'active');
                });

                dom.addClass(event, 'active');

                

                const imagesParallaxUp = document.querySelectorAll('.js-parallax-up');
                const imagesParallaxDown = document.querySelectorAll('.js-parallax-down');

                const windowWidth = window.innerWidth;
                
                if(windowWidth < 1023){ 
                    return
                }

                // dom.forEachEl(instancesParalaxUp, (instance) => {
                //     instance.destroy();
                // });

                // dom.forEachEl(instancesParalaxDown, (instance) => {
                //     instance.destroy();
                // });
                
                
                setTimeout(() => {
                    AOS.refreshHard ();
                    // if (imagesParallaxUp.length > 0) {
                    //     let countimagesParallaxUp = 0;
                    //     dom.forEachEl(imagesParallaxUp, (image) => {
                    //         console.log(image);
                    //         instancesParalaxUp[countimagesParallaxUp] = new simpleParallax(image, {
                    //             orientation: 'up',
                    //             scale: 1.2,
                    //             transition: 'ease',
                    //         });
                    //         countimagesParallaxUp++;
                    //     });
                    // }
                    
    
                    // if (imagesParallaxDown.length > 0) {
                    //     let countimagesParallaxDown = 0;
                    //     dom.forEachEl(imagesParallaxDown, (image) => {
                    //         instancesParalaxDown[countimagesParallaxDown] = new simpleParallax(image, {
                    //             orientation: 'down',
                    //             scale: 1.2,
                    //             transition: 'ease',
                    //         });
                    //         countimagesParallaxDown++;
                    //     });
                    // }
                }, 500);
            }

            
        });
    });
}
export default function(){
    window.addEventListener('turbolinks:load', function() {
        navPodcast();
    });


}
